import axios from 'axios'
import { VitAPI } from '@booking/vit/dist/api'

const vitAPI = new VitAPI(axios, {
  clientId: process.env.REACT_APP_FLOW_CLIENT_ID,
  dolliEndpoint: process.env.REACT_APP_ENDPOINT_DOLLI,
  drupalEndpoint: process.env.REACT_APP_ENDPOINT_DRUPAL,
  redirectUri: process.env.REACT_APP_OAUTH_REDIRECT_URI,
  authorizationEndpoint: process.env.REACT_APP_OAUTH_AUTH_ENDPOINT,
  tokenEndpoint: process.env.REACT_APP_OAUTH_TOKEN_ENDPOINT,
  oauthClientId: process.env.REACT_APP_OAUTH_CLIENT_ID,
  crypto: window.crypto,
  getUserFormat: process.env.REACT_APP_GET_USER_FORMAT || 'json',
})

export default vitAPI
